export default __webpack_public_path__ + "static/media/B0003.e6779ed0.png";